import React from 'react';
import ChangeGamePositionState from './changeGamePositionState/ChangeGamePositionState';
import ChangeGamePosition from './components/ChangeGamePosition/ChangeGamePosition';

const ChangeGamePositionPage: React.FC = () => {
	return (
		<ChangeGamePositionState>
			<ChangeGamePosition />
		</ChangeGamePositionState>
	);
};

export default ChangeGamePositionPage;
